import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { ContactAction, SubItemsSharedAction } from "../actions";
import * as contactApi from "../api/contact";
import { toastr } from "react-redux-toastr";
import { goBack } from "connected-react-router";
import { SetMessage } from "../assets/errorMessages";
import {
  defaultNormalizerWithSeparateMetaObj,
  fetchAllPages
} from "../assets/fetchAllPageTogether";

export function* watcherContact() {
  yield takeLatest(types.GET_CONTACT_REQUEST, get);
  yield takeLatest(types.SHOW_CONTACT_REQUEST, show);
  yield takeLatest(types.REMOVE_CONTACT_REQUEST, remove);
  yield takeLatest(types.STORE_CONTACT_REQUEST, store);
  yield takeLatest(types.UPDATE_CONTACT_REQUEST, update);
}

function* get() {
  try {
    const response = yield fetchAllPages(
      getRequest,
      null,
      defaultNormalizerWithSeparateMetaObj,
      null,
      true
    );
    yield put(ContactAction.getListSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ContactAction.getListFailure(message));
  }
}
function getRequest(pageNumber = null) {
  return contactApi.getList(pageNumber);
}

function* show(action) {
  try {
    const response = yield call(showRequest, action.id);
    yield put(ContactAction.showSuccess(response.data.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ContactAction.showFailure(message));
  }
}
function showRequest(id) {
  return contactApi.show(id);
}

function* remove(action) {
  try {
    const response = yield call(removeRequest, action.id);
    yield put(ContactAction.removeSuccess(action.id));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (action.goBack) {
      yield put(goBack());
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(ContactAction.removeFailure());
  }
}
function removeRequest(id) {
  return contactApi.remove(id);
}

function* store(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(storeRequest, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(ContactAction.storeSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(ContactAction.storeFailure());
  }
}

function storeRequest(data) {
  return contactApi.store(data);
}

function* update(action) {
  try {
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: true }));
    const response = yield call(updateRequest, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(SubItemsSharedAction.closeAddModal());
    yield put(ContactAction.updateSuccess(response.data.data));
  } catch (error) {
    SetMessage(error, true);
    yield put(SubItemsSharedAction.setAddModalInfo({ loading: false }));
    yield put(ContactAction.updateFailure());
  }
}
function updateRequest(id, data) {
  return contactApi.update(id, data);
}
